import React from 'react';
import cn from 'classnames';
import * as s from './styles.scss';

export const FakePaymentMethodIcon: React.FunctionComponent<{
  withBorder?: boolean;
}> = (props) => (
  <img
    className={cn({
      [s.fakePaymentMethod]: true,
      [s.withBorder]: props.withBorder,
    })}
    alt="fakePaymentMethod"
    src="https://www.wix.com/_partials/third-party/cashier-settings/methods/method-icon-fakePaymentMethod.svg"
  />
);
FakePaymentMethodIcon.displayName = 'FakePaymentMethodIcon';
